import { render, staticRenderFns } from "./ImportAlumniContact.vue?vue&type=template&id=2b1b570e&"
import script from "./ImportAlumniContact.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniContact.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports